// import React, { createContext, useState, useContext, useEffect, useCallback, useRef } from "react";
// import wsService from "../ws";
// import { useAuth } from "./AuthContext";
// import { techniquesAPI, citiesAPI, servicesAPI, workSettingsAPI, ordersAPI } from "../api";
// import { getNotifiedOrderNumbers } from "../utils/notifiedOrders";

// const DataContext = createContext();
// export const useData = () => useContext(DataContext);

// const BASE_URL = "https://service-life.ru:3003";

// function extractArray(data, possibleKeys = []) {
//     if (Array.isArray(data)) return data;
//     if (!data || typeof data !== 'object') return [];
//     for (const key of possibleKeys) {
//         if (Array.isArray(data[key])) return data[key];
//     }
//     return [];
// }

// export const DataProvider = ({ children }) => {
//     const { user } = useAuth();

//     const [availableOrders, setAvailableOrders] = useState([]);
//     const [myOrders, setMyOrders] = useState([]);
//     const [reports, setReports] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const isAwaitingPilotOrdersRef = useRef(false);
//     const hasLoadedRef = useRef(false);
//     // Блокировка повторных запросов доступных заказов
//     const isFetchingOrders = useRef(false);

//     const [techniques, setTechniques] = useState([]);
//     const [cities, setCities] = useState([]);
//     const [services, setServices] = useState({});
//     const [workSettings, setWorkSettings] = useState(null);
//     const [loadingStatic, setLoadingStatic] = useState(true);
//     const [averageCheck, setAverageCheck] = useState(null);

//     const formatDate = (isoString) => {
//         if (!isoString) return "";
//         const date = new Date(isoString);
//         if (isNaN(date.getTime())) return isoString;
//         return date.toLocaleDateString("ru-RU", {
//             day: "2-digit", month: "2-digit", year: "numeric",
//             hour: "2-digit", minute: "2-digit",
//         }).replace(",", "");
//     };

//     const mapOrder = (order) => ({
//         id: order.order_id?.toString(),
//         orderNumber: order.order_e,
//         city: `г. ${order.city_user || "не указан"}`,
//         title: [order.name_technic].filter(Boolean).join(" ") || "Техника не указана",
//         technicId: order.order_technic_e,
//         brand: order.order_brand_e || "не указан",
//         age: order.order_technic_years,
//         description: order.order_reason,
//         priceText: order.order_contract_diagnostics == "1"
//             ? order.order_contract_diagnostics_2 || "Не указано"
//             : order.order_contract_diagnostics || "Не указано",
//         commission: `${100 - order.order_master_percent} %`,
//         appointmentDate: order.order_client_date === "01.01.1970" ? "" : order.order_client_date,
//         appointmentTime: [order.order_client_time_s, order.order_client_time_do].filter(Boolean).join(" - "),
//         clientName: order.name_user || "Не указан",
//         clientPhone: order.phone_user,
//         clientAddress: order.order_client_address || "Не указан",
//         requestDate: formatDate(order.order_date),
//         additionalInfo: order.order_master_comment || "—",
//         partner: order.order_from_partner || "не указан",
//         logist: order.order_logist || "",
//         raw: order,
//     });

//     const loadStaticData = useCallback(async () => {
//         if (!user?.uid_master) {
//             setTechniques([]); setCities([]); setWorkSettings(null);
//             setLoadingStatic(false);
//             return;
//         }
//         setLoadingStatic(true);
//         try {
//             const [techRes, cityRes, wsRes] = await Promise.all([
//                 techniquesAPI.getTechniques(),
//                 citiesAPI.getCities(),
//                 workSettingsAPI.getWorkSettings({ userId: user.uid_master }),
//             ]);
//             setTechniques(techRes.data || []);
//             setCities(cityRes.data || []);
//             setWorkSettings(wsRes.data || null);
//         } catch (e) {
//             console.error("Ошибка загрузки статических данных:", e);
//         } finally {
//             setLoadingStatic(false);
//         }
//     }, [user]);

//     const loadServicesForTechnic = useCallback(async (technicId) => {
//         if (!technicId || services[technicId]) return;
//         try {
//             const res = await servicesAPI.getServices(technicId);
//             setServices(prev => ({ ...prev, [technicId]: res.data || [] }));
//         } catch (e) {
//             console.error(`Ошибка загрузки услуг для техники ${technicId}:`, e);
//         }
//     }, [services]);

//     const updateWorkSettings = useCallback(async (settings) => {
//         try {
//             await workSettingsAPI.updateWorkSettings(settings);
//             await loadStaticData();
//         } catch (e) {
//             console.error("Ошибка обновления настроек:", e);
//             throw e;
//         }
//     }, [loadStaticData]);

//     const refreshStaticData = useCallback(() => loadStaticData(), [loadStaticData]);

//     const refreshAvailableOrders = useCallback(async () => {
//         const uid = user?.uid_master;
//         if (!uid || isFetchingOrders.current) return; // блокировка повторов

//         const notifiedNumbers = await getNotifiedOrderNumbers();
//         const banMaster = Number(user.ban_master);

//         isFetchingOrders.current = true; // блокируем до получения ответа
//         console.log(`[refreshAvailableOrders] banMaster=${banMaster}, userId=${uid}`);

//         if (banMaster === 0) {
//             wsService.fetchAvailableOrders({ userId: uid, notifiedOrders: notifiedNumbers });
//         } else {
//             isAwaitingPilotOrdersRef.current = true;
//             wsService.fetchAvailableOrdersPis({ userId: uid, notifiedOrders: notifiedNumbers });
//         }
//     }, [user?.uid_master, user?.ban_master]);

//     const refreshMyOrders = useCallback(() => {
//         if (user?.uid_master) wsService.fetchMyOrders({ userId: user.uid_master });
//     }, [user?.uid_master]);

//     const refreshReports = useCallback(() => {
//         if (user?.uid_master) wsService.fetchReports({ userId: user.uid_master });
//     }, [user?.uid_master]);

//     const fetchOrderByNotification = useCallback(async (orderId) => {
//         if (!user?.uid_master) return null;
//         try {
//             const res = await ordersAPI.getOrderById(orderId, user.uid_master);
//             const data = res.data?.data;
//             return data ? mapOrder(data) : null;
//         } catch (e) {
//             console.error("Ошибка получения заказа по уведомлению:", e);
//             return null;
//         }
//     }, [user?.uid_master]);

//     const removeMyOrder = (orderId) => {
//         setMyOrders(prev => prev.filter(o => o.id !== orderId));
//     };

//     const handleData = useCallback((results) => {
//         console.log("🔔 [handleData] Полный ответ:", results);
//         const data = results?.results || results;
//         const globalData = data?.globalData;
//         const pageData = data?.pageData;

//         if (globalData?.getAppData?.someData?.income) {
//             setAverageCheck(globalData.getAppData.someData.income);
//         }

//         // ---------- Доступные заказы ----------
//         let newAvailable = null;
//         if (pageData?.kn_order) {
//             newAvailable = pageData.kn_order;
//             console.log("👉 Найдены обычные заказы (kn_order)");
//         } else if (pageData?.kn_order_pis) {
//             if (isAwaitingPilotOrdersRef.current) {
//                 newAvailable = pageData.kn_order_pis;
//                 isAwaitingPilotOrdersRef.current = false;
//                 console.log("👉 Найдены пилотные заказы (kn_order_pis)");
//             } else {
//                 console.log("ℹ️ Пилотные заказы проигнорированы (флаг false)");
//             }
//         } else {
//             const possibleSources = [
//                 data?.orders,
//                 data?.data,
//                 data?.availableOrders,
//                 Array.isArray(data) ? data : null,
//             ];
//             for (const src of possibleSources) {
//                 if (Array.isArray(src) && src.length > 0) {
//                     newAvailable = src;
//                     console.log("👉 Заказы найдены в альтернативном поле");
//                     break;
//                 }
//             }
//         }

//         if (newAvailable) {
//             const mapped = newAvailable.map(mapOrder);
//             console.log("✅ Обновлены доступные заказы, количество:", mapped.length);
//             setAvailableOrders(mapped);
//             isFetchingOrders.current = false; // разблокировка
//         } else if (pageData?.kn_order !== undefined || pageData?.kn_order_pis !== undefined) {
//             // Поле было, но пустое
//             setAvailableOrders([]);
//             isFetchingOrders.current = false;
//         } else {
//             // Ответ не содержал заказов – всё равно сбрасываем флаг, если он был установлен
//             if (isFetchingOrders.current) {
//                 isFetchingOrders.current = false;
//             }
//         }

//         // ---------- Мои заказы ----------
//         let newMyOrders = null;
//         if (pageData?.my_order) {
//             newMyOrders = pageData.my_order;
//         } else if (data?.myOrders) {
//             newMyOrders = data.myOrders;
//         } else if (Array.isArray(data) && data.length > 0 && data[0]?.clientPhone) {
//             newMyOrders = data;
//         }
//         if (newMyOrders) {
//             const mapped = (Array.isArray(newMyOrders) ? newMyOrders : [newMyOrders]).map(mapOrder);
//             console.log("✅ Обновлены мои заказы, количество:", mapped.length);
//             setMyOrders(mapped);
//         }

//         // ---------- Отчёты ----------
//         let newReports = null;
//         if (pageData?.orderReports) {
//             newReports = pageData.orderReports;
//         } else if (data?.reports) {
//             newReports = data.reports;
//         } else if (Array.isArray(data) && data.length > 0 && data[0]?.hasOwnProperty('paid')) {
//             newReports = data;
//         }
//         if (newReports) {
//             const orders = Array.isArray(newReports) ? newReports : [newReports];
//             const cardInfoArray = pageData?.cardInfo || data?.cardInfo || [];
//             const reportsOrders = orders.map((order) => {
//                 const base = mapOrder(order);
//                 let photos = [];
//                 if (order.order_report_photos) photos = order.order_report_photos.split(",").map(p => p.trim());
//                 photos = photos.map(p => p.startsWith("http") ? p : `${BASE_URL}${p}`);
//                 let cardData = null;
//                 if (order.cardDetails) cardData = order.cardDetails;
//                 else if (order.credit_card && cardInfoArray.length > 0) {
//                     cardData = cardInfoArray.find(card => card.credit_card === order.credit_card) || null;
//                 }
//                 const repairSum = parseFloat(order.order_report_cheque) || 0;
//                 const amountSum = parseFloat(order.order_report_amount) || 0;
//                 return {
//                     ...base,
//                     repairSum, amountSum,
//                     spareSum: repairSum - amountSum,
//                     commissionSum: parseFloat(order.order_report_commission) || 0,
//                     paid: parseInt(order.order_report_paid, 10) || 0,
//                     comment: order.order_report_comment || "",
//                     photos,
//                     completedAt: order.order_date_report,
//                     cardInfo: cardData,
//                     cardNumber: order.credit_card,
//                     cardBank: cardData?.credit_card_bank,
//                     cardFio: cardData?.credit_card_fio,
//                 };
//             });
//             console.log("✅ Обновлены отчёты, количество:", reportsOrders.length);
//             setReports(reportsOrders);
//         }

//         if (!hasLoadedRef.current && (newAvailable || newMyOrders || newReports)) {
//             hasLoadedRef.current = true;
//             setLoading(false);
//         }
//     }, []);

//     const handleError = useCallback((error) => {
//         console.error("Ошибка от сервера:", error);
//         isFetchingOrders.current = false; // разблокировка при ошибке
//         if (!hasLoadedRef.current) {
//             hasLoadedRef.current = true;
//             setLoading(false);
//         }
//     }, []);

//     const handleConnected = useCallback(() => {
//         console.log("WebSocket подключён");
//         const uid = user?.uid_master;
//         if (uid) {
//             // НЕ вызываем refreshAvailableOrders здесь, чтобы избежать дублирования
//             wsService.fetchMyOrders({ userId: uid });
//             wsService.fetchReports({ userId: uid });
//         }
//     }, [user?.uid_master]);

//     useEffect(() => {
//         wsService.on("data", handleData);
//         wsService.on("error", handleError);
//         wsService.on("connected", handleConnected);
//         return () => {
//             wsService.off("data", handleData);
//             wsService.off("error", handleError);
//             wsService.off("connected", handleConnected);
//         };
//     }, [handleData, handleError, handleConnected]);

//     useEffect(() => {
//         let timeoutId;
//         const loadData = async () => {
//             const uid = user?.uid_master;
//             if (!uid) {
//                 wsService.disconnect();
//                 setLoading(false);
//                 hasLoadedRef.current = false;
//                 return;
//             }
//             setLoading(true);
//             hasLoadedRef.current = false;
//             try {
//                 wsService.disconnect();
//                 await new Promise(r => setTimeout(r, 100));
//                 const connectPromise = wsService.connect();
//                 timeoutId = setTimeout(() => {
//                     if (!hasLoadedRef.current) {
//                         hasLoadedRef.current = true;
//                         setLoading(false);
//                     }
//                 }, 5000);
//                 await connectPromise;
//                 clearTimeout(timeoutId);
//                 refreshAvailableOrders();
//                 wsService.fetchMyOrders({ userId: uid });
//                 wsService.fetchReports({ userId: uid });
//             } catch (error) {
//                 console.error("Ошибка подключения WebSocket:", error);
//                 if (!hasLoadedRef.current) {
//                     hasLoadedRef.current = true;
//                     setLoading(false);
//                 }
//             }
//         };
//         loadData();
//         return () => {
//             if (timeoutId) clearTimeout(timeoutId);
//             wsService.disconnect();
//         };
//     }, [user?.uid_master, refreshAvailableOrders]);

//     useEffect(() => { loadStaticData(); }, [loadStaticData]);

//     const takeOrder = (orderId) => {
//         if (!user?.uid_master) return;
//         ordersAPI.takeOrderWithUser(orderId, user.uid_master)
//             .then(() => {
//                 refreshAvailableOrders();
//                 wsService.fetchMyOrders({ userId: user.uid_master });
//             })
//             .catch(console.error);
//     };

//     const completeOrder = () => console.log("completeOrder не реализован");

//     const stats = {
//         totalTaken: myOrders.length + reports.length,
//         totalCompleted: reports.length,
//         totalEarnings: reports.reduce((sum, r) => sum + (r.repairSum || 0), 0),
//     };

//     return (
//         <DataContext.Provider
//             value={{
//                 availableOrders, myOrders, reports, loading,
//                 takeOrder, completeOrder, stats,
//                 refreshAvailableOrders, fetchOrderByNotification,
//                 refreshMyOrders, refreshReports,
//                 removeMyOrder,
//                 techniques, cities, services, workSettings, loadingStatic,
//                 loadServicesForTechnic, updateWorkSettings, refreshStaticData,
//                 averageCheck,
//             }}
//         >
//             {children}
//         </DataContext.Provider>
//     );
// };

import React, { createContext, useState, useContext, useEffect, useCallback, useRef } from "react";
import wsService from "../ws";
import { useAuth } from "./AuthContext";
import { techniquesAPI, citiesAPI, servicesAPI, workSettingsAPI, ordersAPI } from "../api";
import { getNotifiedOrderNumbers } from "../utils/notifiedOrders";

const DataContext = createContext();
export const useData = () => useContext(DataContext);

const BASE_URL = "https://service-life.ru:3003";

function extractArray(data, possibleKeys = []) {
    if (Array.isArray(data)) return data;
    if (!data || typeof data !== "object") return [];
    for (const key of possibleKeys) {
        if (Array.isArray(data[key])) return data[key];
    }
    return [];
}

export const DataProvider = ({ children }) => {
    const { user } = useAuth();

    const [availableOrders, setAvailableOrders] = useState([]);
    const [myOrders, setMyOrders] = useState([]);
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const isAwaitingPilotOrdersRef = useRef(false);
    const hasLoadedRef = useRef(false);
    const isFetchingOrders = useRef(false);

    const [techniques, setTechniques] = useState([]);
    const [cities, setCities] = useState([]);
    const [services, setServices] = useState({});
    const [workSettings, setWorkSettings] = useState(null);
    const [loadingStatic, setLoadingStatic] = useState(true);
    const [averageCheck, setAverageCheck] = useState(null);

    const formatDate = (isoString) => {
        if (!isoString) return "";
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return isoString;
        return date
            .toLocaleDateString("ru-RU", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            })
            .replace(",", "");
    };

    const mapOrder = (order) => ({
        id: order.order_id?.toString(),
        orderNumber: order.order_e,
        city: `г. ${order.city_user || "не указан"}`,
        title: [order.name_technic].filter(Boolean).join(" ") || "Техника не указана",
        technicId: order.order_technic_e,
        brand: order.order_brand_e || "не указан",
        age: order.order_technic_years,
        description: order.order_reason,
        priceText: order.order_contract_diagnostics == "1" ? order.order_contract_diagnostics_2 || "Не указано" : order.order_contract_diagnostics || "Не указано",
        commission: `${100 - order.order_master_percent} %`,
        appointmentDate: order.order_client_date === "01.01.1970" ? "" : order.order_client_date,
        appointmentTime: [order.order_client_time_s, order.order_client_time_do].filter(Boolean).join(" - "),
        clientName: order.name_user || "Не указан",
        clientPhone: order.phone_user,
        clientAddress: order.order_client_address || "Не указан",
        requestDate: formatDate(order.order_date),
        additionalInfo: order.order_master_comment || "—",
        partner: order.order_from_partner || "не указан",
        logist: order.order_logist || "",
        raw: order,
    });

    const loadStaticData = useCallback(async () => {
        if (!user?.uid_master) {
            setTechniques([]);
            setCities([]);
            setWorkSettings(null);
            setLoadingStatic(false);
            return;
        }
        setLoadingStatic(true);
        try {
            const [techRes, cityRes, wsRes] = await Promise.all([
                techniquesAPI.getTechniques(),
                citiesAPI.getCities(),
                workSettingsAPI.getWorkSettings({ userId: user.uid_master }),
            ]);
            setTechniques(techRes.data || []);
            setCities(cityRes.data || []);
            setWorkSettings(wsRes.data || null);
        } catch (e) {
            console.error("Ошибка загрузки статических данных:", e);
        } finally {
            setLoadingStatic(false);
        }
    }, [user]);

    const loadServicesForTechnic = useCallback(
        async (technicId) => {
            if (!technicId || services[technicId]) return;
            try {
                const res = await servicesAPI.getServices(technicId);
                setServices((prev) => ({ ...prev, [technicId]: res.data || [] }));
            } catch (e) {
                console.error(`Ошибка загрузки услуг для техники ${technicId}:`, e);
            }
        },
        [services],
    );

    const updateWorkSettings = useCallback(
        async (settings) => {
            try {
                await workSettingsAPI.updateWorkSettings(settings);
                await loadStaticData();
            } catch (e) {
                console.error("Ошибка обновления настроек:", e);
                throw e;
            }
        },
        [loadStaticData],
    );

    const refreshStaticData = useCallback(() => loadStaticData(), [loadStaticData]);

    // Обычные заказы – всегда fetchAvailableOrders
    const refreshAvailableOrders = useCallback(async () => {
        const uid = user?.uid_master;
        if (!uid) return;
        if (isFetchingOrders.current) {
            console.log("[refreshAvailableOrders] Уже идёт запрос, пропускаем");
            return;
        }
        const notifiedNumbers = await getNotifiedOrderNumbers();
        isFetchingOrders.current = true;
        console.log("[refreshAvailableOrders] Обычные заказы");
        wsService.fetchAvailableOrders({ userId: uid, notifiedOrders: notifiedNumbers });
    }, [user?.uid_master]);

    // Пилотные заказы – вызывается кнопкой "Обновить"
    const refreshPilotOrders = useCallback(() => {
        const uid = user?.uid_master;
        if (!uid) return;
        // Принудительно снимаем блокировку, если она была установлена автоматическим запросом
        isFetchingOrders.current = false;
        isAwaitingPilotOrdersRef.current = true;
        isFetchingOrders.current = true;
        console.log("[refreshPilotOrders] Пилотные заказы");
        wsService.fetchAvailableOrdersPis({ userId: uid, notifiedOrders: [] });
    }, [user?.uid_master]);

    const refreshMyOrders = useCallback(() => {
        if (user?.uid_master) wsService.fetchMyOrders({ userId: user.uid_master });
    }, [user?.uid_master]);

    const refreshReports = useCallback(() => {
        if (user?.uid_master) wsService.fetchReports({ userId: user.uid_master });
    }, [user?.uid_master]);

    const fetchOrderByNotification = useCallback(
        async (orderId) => {
            if (!user?.uid_master) return null;
            try {
                const res = await ordersAPI.getOrderById(orderId, user.uid_master);
                const data = res.data?.data;
                return data ? mapOrder(data) : null;
            } catch (e) {
                console.error("Ошибка получения заказа по уведомлению:", e);
                return null;
            }
        },
        [user?.uid_master],
    );

    const removeMyOrder = (orderId) => {
        setMyOrders((prev) => prev.filter((o) => o.id !== orderId));
    };

    const handleData = useCallback((results) => {
        console.log("🔔 [handleData] Полный ответ:", results);
        const data = results?.results || results;
        const globalData = data?.globalData;
        const pageData = data?.pageData;

        if (globalData?.getAppData?.someData?.income) {
            setAverageCheck(globalData.getAppData.someData.income);
        }

        // ---------- Доступные заказы ----------
        let newAvailable = null;
        if (pageData?.kn_order) {
            newAvailable = pageData.kn_order;
            console.log("👉 Найдены обычные заказы (kn_order)");
            isAwaitingPilotOrdersRef.current = false;
        } else if (pageData?.kn_order_pis) {
            if (isAwaitingPilotOrdersRef.current) {
                newAvailable = pageData.kn_order_pis;
                isAwaitingPilotOrdersRef.current = false;
                console.log("👉 Найдены пилотные заказы (kn_order_pis)");
            } else {
                console.log("ℹ️ Пилотные заказы проигнорированы (не запрашивались)");
            }
        } else {
            const possibleSources = [data?.orders, data?.data, data?.availableOrders, Array.isArray(data) ? data : null];
            for (const src of possibleSources) {
                if (Array.isArray(src) && src.length > 0) {
                    newAvailable = src;
                    console.log("👉 Заказы найдены в альтернативном поле");
                    break;
                }
            }
        }

        if (newAvailable) {
            const mapped = newAvailable.map(mapOrder);
            console.log("✅ Обновлены доступные заказы, количество:", mapped.length);
            setAvailableOrders(mapped);
        } else if (pageData?.kn_order !== undefined || pageData?.kn_order_pis !== undefined) {
            setAvailableOrders([]);
        }
        isFetchingOrders.current = false; // снимаем блокировку после обработки

        // ---------- Мои заказы ----------
        let newMyOrders = null;
        if (pageData?.my_order) {
            newMyOrders = pageData.my_order;
        } else if (data?.myOrders) {
            newMyOrders = data.myOrders;
        } else if (Array.isArray(data) && data.length > 0 && data[0]?.clientPhone) {
            newMyOrders = data;
        }
        if (newMyOrders) {
            const mapped = (Array.isArray(newMyOrders) ? newMyOrders : [newMyOrders]).map(mapOrder);
            setMyOrders(mapped);
        }

        // ---------- Отчёты ----------
        let newReports = null;
        if (pageData?.orderReports) {
            newReports = pageData.orderReports;
        } else if (data?.reports) {
            newReports = data.reports;
        } else if (Array.isArray(data) && data.length > 0 && data[0]?.hasOwnProperty("paid")) {
            newReports = data;
        }
        if (newReports) {
            const orders = Array.isArray(newReports) ? newReports : [newReports];
            const cardInfoArray = pageData?.cardInfo || data?.cardInfo || [];
            const reportsOrders = orders.map((order) => {
                const base = mapOrder(order);
                let photos = [];
                if (order.order_report_photos) photos = order.order_report_photos.split(",").map((p) => p.trim());
                photos = photos.map((p) => (p.startsWith("http") ? p : `${BASE_URL}${p}`));
                let cardData = null;
                if (order.cardDetails) cardData = order.cardDetails;
                else if (order.credit_card && cardInfoArray.length > 0) {
                    cardData = cardInfoArray.find((card) => card.credit_card === order.credit_card) || null;
                }
                const repairSum = parseFloat(order.order_report_cheque) || 0;
                const amountSum = parseFloat(order.order_report_amount) || 0;
                return {
                    ...base,
                    repairSum,
                    amountSum,
                    spareSum: repairSum - amountSum,
                    commissionSum: parseFloat(order.order_report_commission) || 0,
                    paid: parseInt(order.order_report_paid, 10) || 0,
                    comment: order.order_report_comment || "",
                    photos,
                    completedAt: order.order_date_report,
                    cardInfo: cardData,
                    cardNumber: order.credit_card,
                    cardBank: cardData?.credit_card_bank,
                    cardFio: cardData?.credit_card_fio,
                };
            });
            setReports(reportsOrders);
        }

        if (!hasLoadedRef.current && (newAvailable || newMyOrders || newReports)) {
            hasLoadedRef.current = true;
            setLoading(false);
        }
    }, []);

    const handleError = useCallback((error) => {
        console.error("Ошибка от сервера:", error);
        isFetchingOrders.current = false;
        if (!hasLoadedRef.current) {
            hasLoadedRef.current = true;
            setLoading(false);
        }
    }, []);

    const handleConnected = useCallback(() => {
        console.log("WebSocket подключён");
        const uid = user?.uid_master;
        if (uid) {
            refreshAvailableOrders();
            wsService.fetchMyOrders({ userId: uid });
            wsService.fetchReports({ userId: uid });
        }
    }, [user?.uid_master, refreshAvailableOrders]);

    useEffect(() => {
        wsService.on("data", handleData);
        wsService.on("error", handleError);
        wsService.on("connected", handleConnected);
        return () => {
            wsService.off("data", handleData);
            wsService.off("error", handleError);
            wsService.off("connected", handleConnected);
        };
    }, [handleData, handleError, handleConnected]);

    useEffect(() => {
        let timeoutId;
        const loadData = async () => {
            const uid = user?.uid_master;
            if (!uid) {
                wsService.disconnect();
                setLoading(false);
                hasLoadedRef.current = false;
                return;
            }
            setLoading(true);
            hasLoadedRef.current = false;
            try {
                wsService.disconnect();
                await new Promise((r) => setTimeout(r, 100));
                const connectPromise = wsService.connect();
                timeoutId = setTimeout(() => {
                    if (!hasLoadedRef.current) {
                        hasLoadedRef.current = true;
                        setLoading(false);
                    }
                }, 5000);
                await connectPromise;
                clearTimeout(timeoutId);
                refreshAvailableOrders();
                wsService.fetchMyOrders({ userId: uid });
                wsService.fetchReports({ userId: uid });
            } catch (error) {
                console.error("Ошибка подключения WebSocket:", error);
                if (!hasLoadedRef.current) {
                    hasLoadedRef.current = true;
                    setLoading(false);
                }
            }
        };
        loadData();
        return () => {
            if (timeoutId) clearTimeout(timeoutId);
            wsService.disconnect();
        };
    }, [user?.uid_master, refreshAvailableOrders]);

    useEffect(() => {
        loadStaticData();
    }, [loadStaticData]);

    const takeOrder = (orderId) => {
        if (!user?.uid_master) return;
        ordersAPI
            .takeOrderWithUser(orderId, user.uid_master)
            .then(() => {
                refreshAvailableOrders();
                wsService.fetchMyOrders({ userId: user.uid_master });
            })
            .catch(console.error);
    };

    const completeOrder = () => console.log("completeOrder не реализован");

    const stats = {
        totalTaken: myOrders.length + reports.length,
        totalCompleted: reports.length,
        totalEarnings: reports.reduce((sum, r) => sum + (r.repairSum || 0), 0),
    };

    return (
        <DataContext.Provider
            value={{
                availableOrders,
                myOrders,
                reports,
                loading,
                takeOrder,
                completeOrder,
                stats,
                refreshAvailableOrders,
                refreshPilotOrders,
                fetchOrderByNotification,
                refreshMyOrders,
                refreshReports,
                removeMyOrder,
                techniques,
                cities,
                services,
                workSettings,
                loadingStatic,
                loadServicesForTechnic,
                updateWorkSettings,
                refreshStaticData,
                averageCheck,
            }}>
            {children}
        </DataContext.Provider>
    );
};
